import { ApiError } from '@cmr/react-api-hook';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { UserSession } from './types';

export const actions = {
  fetch: createAsyncAction('fetch/request', 'fetch/success', 'fetch/failure')<
    undefined,
    UserSession[],
    ApiError
  >(),
  sessionChange: createAction('signalR/SessionChange')<UserSession>(),
  sessionEnded: createAction('signalR/SessionEnded')<string>(),
};

export default actions;

export type SessionsAction = ActionType<typeof actions>;
